/**
 * Tipi documento/cartella del fascicolo ottenuti da Folium
 */
export enum RequestResponseFileType {
  Dossier = 'Dossier',
  Document = 'Document',
  Attachment = 'Attachment'
}
